<template>
  <jc-dialog ref="createDialog" :show.sync="show"
             btn-confirm-text='<i class="fas fa-save"></i> Lưu'

             title="Thêm mới"
             type="green"
             @onConfirm="$refs.form.submit()"
  >
    <c-form ref="form" @submit="submit()">
      <c-input v-model.trim="model.application"
               form-group-class="col-md-6 col-sm-6"
               label="Application"
               validate-rules="required"/>
      <c-input v-model.trim="model.profile"
               form-group-class="col-md-6 col-sm-6"
               label="Profile"
               validate-rules="required"/>
      <c-input v-model.trim="model.label" form-group-class="col-md-6 col-sm-6" label="Label" validate-rules="required"/>
      <c-input v-model.trim="model.key" form-group-class="col-md-6 col-sm-6" label="Key" validate-rules="required"/>
      <c-input v-model.trim="model.value" form-group-class="col-md-12 col-sm-12" label="Value"/>
      <c-input v-model.trim="springProperties" form-group-class="col-md-12 col-sm-12" label="Key cấu hình của spring"/>

    </c-form>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "add",
  mixins: [
    dialogMixins,
  ],
  data: function () {
    return {
      model: {
        application: null,
        profile: 'default',
        label: 'latest',
        key: null,
        value: null,
      },
      springProperties: null
    }
  },
  methods: {
    open(item) {
      this.show = true;
      if(item){
        this.model.application = item.application;
        this.model.profile = item.profile;
        this.model.label = item.label;
        this.model.key = item.key;
        this.model.value = item.value;
      }
      this.springProperties = null;
    },
    resetForm() {
      this.model.key = null;
      this.model.value = null;
      this.springProperties = null;
    },
    submit: function () {
      this.$showLoader();
      let data = {
        "application": this.model.application,
        "profile": this.model.profile,
        "label": this.model.label,
        "key": this.model.key,
        "value": this.model.value ? this.model.value : '',
      }
      this.$http
          .post("/cms/api/v1.0/system-config-properties", data)
          .then(successRes => {
            this.model.key = null;
            this.model.value = null;
            this.springProperties = null;
            this.$success();
            this.$stopLoader();

            this.$emit("success", successRes);
          }, errorRes => {
            this.$stopLoader();
            this.errorNotify(errorRes)
                .then(errorRes => this.$cmsBadRequest(errorRes));
            this.$emit("error", errorRes);
          })
      ;
    }
  },
  watch: {
    "springProperties": function (value) {
      let v = value.split("=");
      this.model.key = v[0]?.trim();
      this.model.value = v[1]?.trim();
    }
  }
}
</script>

<style scoped>

</style>